/**
 * ログインを必要とする範囲の入口。
 *
 * トークンはメモリにしか無いので、リロードすると必ずここを通り直す。
 * 黙って取り直せないときはログイン画面へ送る（戻り先は覚えておく）。
 */

import { Navigate, Outlet, useLocation } from "react-router";
import { LoadingState, useAuthState } from "visumo-data-agent-web-shared";

import { ViewerProvider } from "./ViewerContext";

export function AuthenticatedArea() {
  const state = useAuthState();
  const location = useLocation();

  if (state.status === "initializing" || state.status === "authorizing") {
    return <LoadingState label="ログイン状態を確かめています" />;
  }
  if (state.status !== "authenticated") {
    return (
      <Navigate
        to="/login"
        replace
        state={{ returnTo: `${location.pathname}${location.search}` }}
      />
    );
  }
  return (
    <ViewerProvider>
      <Outlet />
    </ViewerProvider>
  );
}
